import { faLocationDot as fasLocationDot } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PromisePool, upperFirst } from "@shared/ui";
import { CityData } from "@shared/lib/city-id";
import autobind from "autobind-decorator";
import type { ReactNode } from "react";
import type { FormInputProps, FormInputState } from "./FormInput";
import { FormInput } from "./FormInput";

const MAX_DATALIST_LENGTH = 15;
const SPLITED_DATALIST_LENGTH = 10;

interface State extends FormInputState {
	dataList: string[];
}

export class FormCity extends FormInput<string, FormInputProps, State> {
	private readonly promisePool = new PromisePool();

	public static defaultProps: Partial<FormInputProps> = {
		prepend: <FontAwesomeIcon icon={fasLocationDot} />,
		dataList: [""], // Fake list
	};

	@autobind
	protected format(value: string): string {
		if (!value || typeof value !== "string") {
			return value;
		}

		return upperFirst(value);
	}

	protected getInitialState(): State {
		return { ...super.getInitialState(), dataList: [] };
	}

	public componentDidMount(): void {
		super.componentDidMount();

		this.promisePool.add(CityData.getList()).then((dataList) => {
			this.setState({
				dataList,
			});
		});
	}

	public componentWillUnmount(): void {
		super.componentWillUnmount();

		this.promisePool.cancel();
	}

	protected renderDataList(dataListId: string, _dataList: string[], value: string): ReactNode {
		const { dataList } = this.state;

		if (dataList) {
			return (
				<datalist id={dataListId}>
					{dataList
						.filter((item) => {
							const typed = `${String(value)}`.toLowerCase();
							const listItem = `${String(item)}`.toLowerCase();

							return (
								(!value && dataList.length < MAX_DATALIST_LENGTH) ||
								(listItem.startsWith(typed) && listItem !== typed)
							);
						})
						.slice(0, this.props.dataListLength || SPLITED_DATALIST_LENGTH)
						.map((item: string) => (
							<option key={item} value={`${item}`} />
						))}
				</datalist>
			);
		}

		return null;
	}

	@autobind
	protected handleValidate(value: string, allValues: Record<string, any>): string {
		const { required } = this.props;
		const { dataList } = this.state;

		if (this.isDisabled()) {
			return undefined;
		}

		if (!(required || value)) {
			return;
		}

		if (!value) {
			return "Válassz ki egy települést!";
		}

		if (dataList?.length && !dataList.includes(value.trim())) {
			return "A megadott település nem található!";
		}

		return super.handleValidate(value, allValues);
	}
}
